module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/774c7d89f540ef070b50361925a794d0.png";